// extracted by mini-css-extract-plugin
export default {"selectMaterial":"attribute_selectMaterial__5ap3C"};